import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCartEntryAdapter } from '@spartacus/cart/base/occ';
import { CART_MODIFICATION_NORMALIZER, CartModification } from '@spartacus/cart/base/root';
import { getToken } from '../utils/getToken';

@Injectable({
  providedIn: 'root',
})
export class CustomOccCartEntryAdapter extends OccCartEntryAdapter {
  public override add(userId: string, cartId: string, productCode: string, quantity: number = 1, pickupStore?: string) {
    const url = this.occEndpointsService.buildUrl('addEntries', {
      urlParams: { userId, cartId, quantity },
    });

    const token = getToken();
    if (url.includes(`quantity=${quantity}`)) {
      const httpHeaders = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
      });

      return this.http
        .post<CartModification>(url, {}, { headers: httpHeaders, params: { code: productCode } })
        .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
    }

    const toAdd = {
      quantity,
      product: { code: productCode },
      ...(pickupStore && { deliveryPointOfService: { name: pickupStore } }),
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http
      .post<CartModification>(url, toAdd, { headers })
      .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
  }
}
